import { NuxtCookies } from 'cookie-universal-nuxt'
import { Store } from 'vuex'
import { RootState } from '@/store'
import * as types from '@/store/talk/types'
import TalkEntity, { ITalkProps } from '@/entities/Talk'
import { IResponseProps } from '@/entities/Response'

export default class TalkRepository {
  private cookies: NuxtCookies
  private store: Store<RootState>

  constructor(cookies: NuxtCookies, store: Store<RootState>) {
    this.cookies = cookies
    this.store = store
  }

  set data(value: IResponseProps<ITalkProps>) {
    this.store.commit(new types.Store({ ...value }))
  }

  get data(): IResponseProps<ITalkProps> {
    return { ...this.store.state.talk.response }
  }

  set searched(value: IResponseProps<ITalkProps>) {
    this.store.commit(new types.Searched({ ...value }))
  }

  get searched(): IResponseProps<ITalkProps> {
    return { ...this.store.state.talk.searched }
  }

  set selected(value: ITalkProps | null) {
    this.store.commit(new types.Selected(value))
  }

  get selected(): ITalkProps | null {
    return this.store.state.talk.selected
  }

  set current(value: ITalkProps | null) {
    this.store.commit(new types.Current(value))
  }

  get current(): ITalkProps | null {
    return this.store.state.talk.current
  }

  get entity(): TalkEntity {
    return new TalkEntity(this.store.state.talk.current)
  }

  set filter(value: string) {
    this.store.commit(new types.Filter(value))
  }

  get filter(): string {
    return this.store.state.talk.filter
  }

  set saving(value: boolean | null) {
    this.store.commit(new types.Saving(value))
  }

  get saving(): boolean | null {
    return this.store.state.data.saving
  }

  read(count: number) {
    if (this.data.byIds) {
      let byIds: { [id: string]: ITalkProps } = {}

      for (let i = 0; i < Math.min(count, this.data.items.length); i++) {
        const id = this.data.items[i].id!
        byIds = { ...byIds, [id]: { ...this.data.byIds[id], readsCount: this.data.byIds[id].readsCount + 1 } }
      }
      byIds = { ...this.data.byIds, ...byIds }
      this.store.commit(new types.Store({ ...this.data, byIds, items: Object.values(byIds) }))
    }
  }
}
